export default "__VITE_PUBLIC_ASSET__e167b305__"